import classNames from "classnames";
import { UserImageWithFallback } from "@/react/components/shared/uikit/UserImageWithFallback";
import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { Icon } from "@circle-react-shared/Icon";

export const MentionItem = ({ member, isSelected, handleClick }: any) => (
  <button
    type="button"
    data-testid="mention-item"
    className={classNames(
      "hover:bg-tertiary flex w-full cursor-pointer items-center px-3 py-1.5",
      { "bg-tertiary": isSelected },
    )}
    onClick={handleClick}
  >
    <div className="mr-3">
      {member.type === "group_mention" ? (
        <Icon type="20-members" size={20} className="!text-darkest ml-1 mr-2" />
      ) : (
        <UserImageWithFallback
          size="8"
          name={member.name}
          src={member.avatar_url}
        />
      )}
    </div>

    <Typography.LabelSm weight="medium">{member.name}</Typography.LabelSm>
  </button>
);
